$(window).on('load', function () {
  // setQuantity();
  itemRemove();
  // if ($('#wrapper').hasClass('home')) {
  //   setNews();
  // }
});

//重要ニュース
// function setNews() {
//   //重要ニュースがある場合はhasNewsクラスとnewsActiveクラスを#wrapperに付与（liquid側と連動制御ください）
//   $('#wrapper').addClass('hasNews');
//   $('#wrapper').addClass('newsActive');
//   //背面を固定する
//   if ($('#wrapper').hasClass('hasNews')) {
//     $('#outerMenu').css('top', 0);
//   }
//   //クローズで消去
//   $('#newsBlocker,.js-news-close').click(function () {
//     $('#wrapper').removeClass('hasNews');
//     $('#newsPanel').fadeOut('fast');
//   });
// }

//cookie制御を入れる場合の重要ニュース
function setNews() {
  if ($.cookie('jackNews') != 'on') {
    //重要ニュースがある場合はhasNewsクラスとnewsActiveクラスを#wrapperに付与（liquid側と連動制御ください）
    $('#wrapper').addClass('hasNews');
    $('#wrapper').addClass('newsActive');

    //背面を固定する
    if ($('#wrapper').hasClass('hasNews')) {
      $('#outerMenu').css('top', 0);
    }
  }
  //クローズで消去
  $('#newsBlocker,.js-news-close').click(function () {
    $('#wrapper').removeClass('hasNews');
    $('#newsPanel').fadeOut('fast');
    //cookie期限を設定する場合
    // let date = new Date();
    // date.setTime(date.getTime() + 1 * 60 * 60 * 1000);
    // $.cookie('jackNews', 'on', { expires: date });
    $.cookie('jackNews', 'on');
  });
}

//quantityInput +-でカウントアップするモジュール
// function setQuantity() {
//   $('.js-plus').click(function () {
//     $(this)
//       .prev()
//       .val(+$(this).prev().val() + 1);
//   });
//   $('.js-minus').click(function () {
//     if ($(this).next().val() > 0) {
//       if ($(this).next().val() > 0)
//         $(this)
//           .next()
//           .val(+$(this).next().val() - 1);
//     }
//   });
// }

//カートアイテム削除ボタンモック用
function itemRemove() {
  //アイテムがない場合はメッセージ表示
  const itemCount = $('#cartModal .item').length;
  if (itemCount == 0) {
    $('.cartMsg').addClass('cartEmpty');
    $('.js-cartSubmit').addClass('dis');
  }
  $('#cartModal').on('click', '.js-itemRemove', function () {
    const target = $(this).parents('.item');
    target.fadeOut(500, function () {
      $(this).remove();
      //アイテムがない場合はメッセージ表示
      const itemCount = $('#cartModal .item').length;
      if (itemCount == 0) {
        $('.cartSection').addClass('cartEmpty');
        $('.js-cartSubmit').addClass('dis');
      }
    });
  });
}
